import { portalPaths } from '@provision/portal-routes';
import { NavigationDataItem } from 'src/components/Navbar/use-navigation-items';
import { RULES_MAP_PER_VIEW_ENTITY } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';

export const CRM_NAVIGATION: NavigationDataItem[] = [
  {
    id: EntityNames.Site,
    title: 'Sites',
    iconData: { name: 'home_work' },
    path: portalPaths.crm.organizations(),
  },
  {
    id: EntityNames.Client,
    title: 'Clients',
    iconData: { name: 'people_outline' },
    path: portalPaths.crm.users(),
  },
  {
    id: EntityNames.Project,
    title: 'Projects',
    iconData: {
      name: 'perm_media',
    },
    path: portalPaths.crm.projects(),
  },
].map((item) => ({
  ...item,
  ...RULES_MAP_PER_VIEW_ENTITY[item.id],
  isMultitenancyAllowed: false,
  isMobileSupported: false,
}));
